NProgress.start(), $.fn.exists = function() {
    return $(this).length > 0 ? !0 : !1
}, $.fn.inView = function() {
    var e = $(window);
    obj = $(this);
    var a = e.scrollTop(),
        o = e.scrollTop() + e.height(),
        t = obj.offset().top + 20;
    return o >= t && t >= a ? !0 : !1
};
var roar = {
    touch: !1,
    clickEv: "click",
    init: function() {
    	roar.addToWishlist(), roar.removeFromWishlist();
        roar.detectPlatform(), roar.detectOptions(), roar.handleEffect(), roar.callbackImagesLoaded(), roar.notifyIE7Users(), roar.handleTooltip(), roar.handleCountdown(), roar.handleTabs(), roar.handleSearch(), roar.callbackSearchMobile(), roar.goToPage(), roar.handleScreenshotPreview(), roar.handleCartSidebar(), roar.handleDropdown(), roar.resetProductImg(), roar.socialSharing(), $(".noclose").click(function(e) {
            e.stopPropagation()
        }), roar.handleScrollToTop(), roar.handleSmoothScroll(), roar.handleTabScroll(), $(".product-fancybox-buttons").length && $(".product-fancybox-buttons").fancybox({
            closeBtn: !1,
            helpers: {
                buttons: {}
            }
        }), fakewaffle.responsiveTabs(["xs", "sm"])
    },
    
  removeFromWishlist: function() {
    $(document).on("click", ".remove-wishlist", function(a) {
      a.preventDefault();
      var b = $(this),
          c = b.closest("form"),
          d = {
            action: "remove_wishlist"
          };
      return d = c.serialize() + "&" + $.param(d), $.ajax({
        type: "POST",
        url: "/a/wishlist",
        async: !0,
        cache: !1,
        data: d,
        dataType: "json",
        beforeSend: function() {
          $(".page-wishlist").addClass("is_loading")
        },
        error: function(a) {
          console.log(a), $(".page-wishlist").removeClass("is_loading")
        },
        success: function(a) {
          1 == a.code ? b.closest(".item").slideUp("fast", function() {
            b.closest(".item").remove(), $(".page-wishlist .infos").removeClass("hide"), $(".wishlist_items_number").text(a.json), 0 == a.json && $(".wishlist-empty").removeClass("hide")
          }) : (alert(a.json), console.log(a.json)), $(".page-wishlist").removeClass("is_loading")
        }
      }), !1
    });
  },
  addToWishlist: function() {
    $(document).on("click", ".add-to-wishlist:not(.added)", function(a) {
      if ($(this).hasClass("need-login")) {
        var b = $("#wishlist_error").html();
        return $.notify({
          message: b,
          target: "_blank"
        }, {
          type: "info",
          showProgressbar: !0,
          z_index: 2031,
          mouse_over: "pause",
          placement: {
            from: "top",
            align: window.rtl ? "left" : "right"
          }
        }), !1
      }
      var c = $(this),
          d = c.closest("form"),
          e = {
            action: "add_wishlist"
          }
      if(c.hasClass('addToDorWishlist')) {
          var ct = c.closest('.product-container').find('.wishlist-button');
      }else{
          var ct = c.closest('.product-container').find('.addToDorWishlist');
      }
      return e = d.serialize() + "&" + $.param(e), $.ajax({
        type: "POST",
        url: "/a/wishlist",
        async: !0,
        cache: !1,
        data: e,
        dataType: "json",
        beforeSend: function() {
          c.attr("data-original-title", c.attr("data-loading-text"))
          .tooltip('fixTitle')
          .tooltip('show')
          .find("span")
          .text(c.attr("data-loading-text"))
        },
        complete: function() {
          c.attr("data-original-title", c.attr("data-added"))
          .tooltip('fixTitle')
          .tooltip('show')
          .find("span")
          .text(c.attr("data-added"));
          c.attr("data-original-title", c.attr("data-success"))
          .find("span")
          .text(c.attr("data-added"));
          c.addClass('added');
          ct.length > 0 && ct.attr("data-original-title", ct.attr("data-success"))
          .find("span")
          .text(ct.attr("data-added"));
          ct.addClass('added');
          
        },
        error: function(a) {
          var b = i = $.parseJSON(a.responseText),
              c = b.message + ": " + b.description;
        },
        success: function() {
          var a = c.closest(".product"),
              b = [{
                product_url: a.find(".name a").attr("href"),
                product_name: a.find(".name a").text()
              }];
          
        }
      }), !1
    })
  },
    handleEffect: function() {
        var e = $(".animated:not(.shown)");
        e.exists() && (setTimeout(function() {
            roar.loadingEffect()
        }, 100), $(window).on("scroll", function() {
            roar.loadingEffect()
        }))
    },
    loadingEffect: function() {
        var e = $(".animated:not(.shown)");
        e.exists() && roar.precessEffect(e)
    },
    precessEffect: function(e) {
        var a = 0;
        e.each(function() {
            var e = $(this);
            $("html.touch").length > 0 ? e.hasClass("shown") || e.hasClass("animation-triggered") || (e.addClass("animation-triggered"), setTimeout(function() {
                e.hasClass("animation-triggered") && e.removeClass("animation-triggered").addClass("shown")
            }, 200)) : e.hasClass("shown") || e.hasClass("animation-triggered") || !e.inView() || (e.addClass("animation-triggered"), a++, setTimeout(function() {
                e.hasClass("animation-triggered") && e.removeClass("animation-triggered").addClass("shown")
            }, 100 * a))
        })
    },
    detectPlatform: function() {
      if($("html.touch").length > 0 && roar.isMobile() != 1) {
      	$("html").removeClass('touch');
      }
      roar.isMobile() ? (roar.touch = !0, $("body").addClass("touch"), roar.clickEv = "touchstart") : ($("body").addClass("notouch"), -1 != navigator.appVersion.indexOf("Mac") && navigator.userAgent.indexOf("Safari") > -1 && $("body").addClass("macos"))
    },
    isMobile: function() {
        var e = navigator.userAgent.toLowerCase();
      	if(this.getWidthBrowser() >= 992){
        	return !1;
        }
        return Modernizr.touch || e.match(/(iphone|ipod|ipad)/) || e.match(/(android)/) || e.match(/(iemobile)/) || e.match(/iphone/i) || e.match(/ipad/i) || e.match(/ipod/i) || e.match(/blackberry/i) || e.match(/bada/i) || e.match(/windows phone/i) || e.match(/webOS/i) ? !0 : !1
    },
    getWidthBrowser: function() {
        var e;
        return "number" == typeof window.innerWidth ? e = window.innerWidth : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? e = document.documentElement.clientWidth : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientWidth), e
    },
    getHeightBrowser: function() {
        var e;
        return "number" == typeof window.innerHeight ? e = window.innerHeight : document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight) ? e = document.documentElement.clientHeight : document.body && (document.body.clientWidth || document.body.clientHeight) && (e = document.body.clientHeight), e
    },
    goToPage: function() {
        $(".action_page").click(function(e) {
            var a = $(this).parent(),
                o = $(".go_page", a).val();
            Shopify.queryParams.page = o, location.search = $.param(Shopify.queryParams)
        }), $(".go_page").on("keypress", function(e) {
            if ("13" == e.which) {
                var a = $(this).val();
                Shopify.queryParams.page = a, location.search = $.param(Shopify.queryParams)
            }
        })
    },
    handleFocus: function() {
        $(".form-focus input").focus(function() {
            $(this).parents(".form-focus").addClass("focus")
        }).blur(function() {
            $(this).parents(".form-focus").removeClass("focus")
        })
    },
    handleBoxLogin: function() {
        $("#loginBox input").focus(function() {
            $(this).parents("#loginBox").addClass("focus")
        }).blur(function() {
            $(this).parents("#loginBox").removeClass("focus")
        })
    },
    handleDropdown: function() {
        $(".dropdown-link").on("click", function() {
            if (0 == roar.touch && roar.getWidthBrowser() > 980) {
                var e = $(this).attr("href");
                window.location = e
            }
        }), roar.handleBoxLogin(), roar.handleFocus()
    },
    handleScrollToTop: function() {
        function e(e) {
            var a = $("#scroll-top");
            a.removeClass("off on"), "on" == e ? a.addClass("on") : a.addClass("off")
        }
        $(window).scroll(function() {
            var a = $(this).scrollTop(),
                o = $(this).height();
            if (a > 0) var t = a + o / 2;
            else var t = 1;
            e(1e3 > t ? "off" : "on")
        }), $("#scroll-top").click(function(e) {
            e.preventDefault(), $("html,body").animate({
                scrollTop: 0
            }, 800, "swing")
        })
    },
    handleScreenshotPreview: function() {
        var e = 100,
            a = 50;
        $(".screenshot").hover(function(o) {
            $("body").append("<p id='screenshot'><span></span><img src='" + $(this).attr("data-rel") + "' alt='' /></p>"), $(this).hasClass("odd") ? $("#screenshot").css("top", o.pageY - e + "px").css("right", o.pageX + a + "px").fadeIn("fast") : $(this).hasClass("even") && $("#screenshot").css("top", o.pageY - e + "px").css("left", o.pageX + a + "px").fadeIn("fast")
        }, function() {
            $("#screenshot").remove()
        }), $(".screenshot").mousemove(function(o) {
            $(this).hasClass("odd") ? $("#screenshot").css("top", o.pageY - e + "px").css("right", o.pageX + a + "px") : $(this).hasClass("even") && $("#screenshot").css("top", o.pageY - e + "px").css("left", o.pageX + a + "px")
        })
    },
    alwaysRefreshZoomQS: function() {
        if (0 == roar.touch && ("zoom" == window.main_image_display || "both" == window.main_image_display) && $(".elevatezoom_qs").length) {
            var e = $(".elevatezoom_qs .img-zoom");
            e.elevateZoom({
                gallery: "gallery_main_qs",
                galleryActiveClass: "active",
                zoomType: "window",
                cursor: "pointer",
                zoomWindowFadeIn: 300,
                zoomWindowFadeOut: 300,
                scrollZoom: !1,
                easing: !0,
                loadingIcon: window.loader_gif
            }), "both" == window.main_image_display && $(".elevatezoom_qs .img-zoom").bind("click", function(e) {
                var a = $(".elevatezoom_qs .img-zoom").data("elevateZoom");
                return $.fancybox(a.getGalleryList(), {
                    closeBtn: !1,
                    helpers: {
                        buttons: {}
                    }
                }), !1
            })
        }
    },
    alwaysScrollThumbsQS: function() {
        $("#gallery_main_qs").length && $("#quick-shop-image").on(roar.clickEv, ".image-thumb", function() {
            var e = $(this),
                a = e.parents(".product-image-wrapper"),
                o = e.attr("data-image-zoom"),
                t = e.attr("data-image");
            return a.find(".image-thumb").removeClass("active"), e.addClass("active"), a.find(".main-image").find("img").attr("data-zoom-image", o), a.find(".main-image").find("img").attr("src", t).load(function() {}), !1
        })
    },
    handleTooltip: function() {
        $(".btooltip").length && $(".btooltip").tooltip()
    },
    handleTabs: function() {
        $("body").on("click", ".nav-tabs a", function(e) {
            e.preventDefault(), $(this).tab("show")
        })
    },
    getRandomInt: function() {
        return Math.floor(Math.random() * (t - e + 1)) + e
    },
    handleCartSidebar: function() {
        jQuery(".cart-controller").click(function(e) {
            e.stopPropagation(), jQuery(".cart-sidebar").toggleClass("opened"), jQuery("html,body").toggleClass("cart-opened")
        }), jQuery("#page").click(function() {
            jQuery(".cart-sidebar").removeClass("opened"), jQuery("html,body").removeClass("cart-opened")
        })
    },
    resetProductImg: function() {
        $("#product-image #main-image").load(function() {
            $(".main-image-bg").hide(), $("#product-image .main-image div").hide()
        })
    },
    handleSearch: function() {
        $(".search-wrapper2 .search-submit").click(function() {
            var e = $(this).parents(".search-form"),
                a = $("#input-ajax", e);
            $(this).hasClass("active") ? e.submit() : (a.css("visibility", "visible"), $(this).addClass("active"), a.focus())
        }), $(".search-wrapper4 .search-submit").click(function() {
            var e = $(this).parent();
            e.hasClass("active") ? (e.removeClass("active"), $("#header").removeClass("is_search")) : (e.addClass("active"), $("#header").addClass("is_search"))
        }), $(document).click(function(e) {
            $(e.target).closest(".search-wrapper2 .search-form").length || $(".search-wrapper2 .search-form").is(":visible") && ($(".search-wrapper2 .search-form #input-ajax").css("visibility", "hidden"), $(".search-wrapper2 .search-form .search-submit").removeClass("active")), $(e.target).closest(".search-wrapper4").length || $(".search-wrapper4 .search-table-wraper").is(":visible") && ($(".search-wrapper4").removeClass("active"), $("#header").removeClass("active"))
        })
    },
    callbackSearchMobile: function() {
        var e = $(".is-mobile .is-mobile-search .fa-search"),
            a = $(".is-mobile .is-mobile-search .fa-times"),
            o = $(".is-mobile .is-mobile-search .input-search"),
            t = $(".is-mobile .is-mobile-search");
        e.click(function() {
            t.addClass("on"), o.focus()
        }), o.click(function() {
            return !1
        }), a.click(function() {
            t.removeClass("on")
        })
    },
    ajaxAllProducts: function() {
        var e = new Array,
            a = "/collections/all?view=ajax";
        return $.ajax({
            type: "GET",
            url: a,
            beforeSend: function() {},
            success: function(a) {
                var o = $(a).find(".p");
                o.each(function() {
                    var a = $.trim(this.getAttribute("data-t")),
                        o = $.trim(this.getAttribute("data-h")),
                        t = new Object;
                    t.title = a, t.handle = o, e.push(t)
                })
            },
            dataType: "html"
        }), e
    },
    handleCountdown: function() {
        $(".count_holder_big").each(function() {
            var e = $(this).find(".count_holder_small");
            $(this).hover(function() {
                e.addClass("hover").appendTo("body")
            }, function() {
                e.removeClass("hover").appendTo(this)
            }).mousemove(function(a) {
                var o = a.pageX + 60,
                    t = a.pageY - 50,
                    i = e.width(),
                    s = e.height(),
                    n = $(window).width() - (o + i);
                $(window).height() - (t + s), 50 > n && (o = a.pageX - i - 60), e.css({
                    left: o,
                    top: t
                })
            })
        })
    },
    handleSmoothScroll: function() {
        $("body").on("click", ".smoothscroll", function(e) {
            e.preventDefault();
            var a = $(this).attr("href");
            $(a).find(".accordion-toggle").hasClass("collapsed") && $(a).find(".accordion-toggle").trigger("click"), setTimeout(function() {
                $("html,body").animate({
                    scrollTop: $(a).offset().top - 100
                }, 800, "swing")
            }, 300)
        })
    },
    handleTabScroll: function() {
        $("body").on("click", ".tabscroll", function(e) {
            e.preventDefault();
            var a = $(this).attr("href");
            $(a).trigger("click"), setTimeout(function() {
                $("html,body").animate({
                    scrollTop: $(a).offset().top
                }, 800, "swing")
            }, 300)
        })
    },
    notifyIE7Users: function() {
        if ($("html").hasClass("ie8") || $("html").hasClass("ie7"))
            if (window.notify_ie8_page) $.ajax({
                type: "GET",
                url: "pages/" + window.notify_ie8_page,
                beforeSend: function() {},
                success: function(e) {
                    var a = $(e).find("#col-main > .page > .page_content");
                    $("body").html(a.html()).show()
                },
                dataType: "html"
            });
            else {
                var e = "<h1>Unsupported Browser</h1>";
                $("body").html(e).show()
            }
    },
    socialSharing: function() {
        var e = $(".social-sharing"),
            a = e.find("a.share"),
            o = e.attr("data-permalink"),
            t = $(".share-facebook"),
            i = $(".share-twitter"),
            s = $(".share-pinterest"),
            n = $(".share-google");
        t.length && $.getJSON("https://graph.facebook.com/?id=" + o + "&callback=?", function(e) {
            e.shares ? t.find(".share-count").text(e.shares).addClass("is-loaded") : t.find(".share-count").remove()
        }), i.length && $.getJSON("https://cdn.api.twitter.com/1/urls/count.json?url=" + o + "&callback=?", function(e) {
            e.count > 0 ? i.find(".share-count").text(e.count).addClass("is-loaded") : i.find(".share-count").remove()
        }), s.length && $.getJSON("https://api.pinterest.com/v1/urls/count.json?url=" + o + "&callback=?", function(e) {
            e.count > 0 ? s.find(".share-count").text(e.count).addClass("is-loaded") : s.find(".share-count").remove()
        }), n.length && n.find(".share-count").addClass("is-loaded"), a.on("click", function(e) {
            e.preventDefault();
            var a = $(this),
                o = a.attr("class").replace("-", "_"),
                t = a.attr("href"),
                i = 700,
                s = 400;
            switch (o) {
                case "share-twitter":
                    s = 300;
                    break;
                case "share-fancy":
                    i = 480, s = 720;
                    break;
                case "share-google":
                    i = 500
            }
            window.open(t, o, "width=" + i + ", height=" + s)
        })
    },
    detectOptions: function() {
        roar.getWidthBrowser() < 992 ? jQuery("#product-header-first").is(":empty") && jQuery("#product-header").detach().appendTo("#product-header-first") : jQuery("#product-header-first").is(":empty") || jQuery("#product-header").detach().appendTo("#product-header-last")
    },
    callbackImagesLoaded: function() {
      	$("#latest-posts").length && $("#latest-posts").on("hover", ".latest-post", function() {
            $("#latest-posts .latest-post").removeClass("active"), $(this).addClass("active")
        })
    }
};
$(window).resize(function() {
    roar.detectOptions()
}), $(window).scroll(function() {
    var e = $(this).scrollTop();
}), jQuery(document).ready(function(e) { roar.init(), NProgress.done()
});